import { PRIVATE } from '@/plugins/acl/const'

const apps = [
  {
    path: '/apps/calendar',
    name: 'apps-calendar',
    component: () => import('@/views/apps/calendar/Calendar.vue'),
    meta: {
      layout: 'content',
    },
  },

  //
  //* ——— Invoice ——————————————————
  //

  {
    path: '/apps/invoice/list',
    name: 'apps-invoice-list',
    component: () => import('@/views/apps/invoice/invoice-list/InvoiceList.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/apps/invoice/preview/:id',
    name: 'apps-invoice-preview',
    component: () => import('@/views/apps/invoice/invoice-preview/InvoicePreview.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/apps/invoice/add/',
    name: 'apps-invoice-add',
    component: () => import('@/views/apps/invoice/invoice-add/InvoiceAdd.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/apps/invoice/edit/:id',
    name: 'apps-invoice-edit',
    component: () => import('@/views/apps/invoice/invoice-edit/InvoiceEdit.vue'),
    meta: {
      layout: 'content',
    },
  },

  //
  //* ——— Templates (documents — demo / hidden from product nav) ——————————————————
  //

  {
    path: '/templates/documents',
    name: 'apps-document-templates-list',
    component: () => import('@/views/apps/templates/document/document-list/DocumentList.vue'),
    meta: {
      layout: 'content',
      resource: PRIVATE.SHINE_FEATURES,
    },
  },
  {
    path: '/templates/document/:id',
    name: 'apps-document-templates-view',
    component: () => import('@/views/apps/templates/document/document-view/DocumentView.vue'),
    meta: {
      layout: 'content',
      resource: PRIVATE.SHINE_FEATURES,
      navActiveLink: 'apps-document-templates-list',
      breadCrumb(context) {
        return [
          {
            text: 'document',
            useI18n: true,
            to: { name: 'apps-document-templates-list' },
          },
          {
            text: context.documentTemplateName,
            useI18n: false,
          },
        ]
      },
    },
  },

  //
  //* ——— Chat ——————————————————
  //

  {
    path: '/apps/chat',
    name: 'apps-chat',
    component: () => import('@/views/apps/chat/Chat.vue'),
    meta: {
      layout: 'content',
    },
  },
]

export default apps
